import React, { useState, useEffect, useContext } from "react";
import "../common/custom_css.css";
import AuthContext from "../common/AuthContext";
import { API } from "../common/api-service";
import { Link, useHistory } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";

export default function Authors() {
  const history = useHistory();
  const COLUMN_WIDTH = 250;
  const { authState } = useContext(AuthContext);
  const token = authState.token.slice(1, -1);

  const deleteRow = (id) => {
    if (window.confirm("Are you sure you wish to delete this item?"))
      API.updateItem("authors", id, { active: false }, token)
        .then((resp) => {
          API.getItems("authors/", token)
            .then((resp2) => {
              const rows = createRowsList(resp2, columns);
              setState({
                ...state,
                columns: columns,
                rows: rows,
              });
            })
            .catch((error) => console.log(error));
          history.push("/authors/");
        })
        .catch((error) => console.log(error));
  };

  const columns = React.useMemo(
    () => [
      {
        field: "actions",
        type: "actions",
        headerName: "Actions",
        width: 200,
        cellClassName: "actions",
        getActions: (params) => {
          return [
            <GridActionsCellItem
              icon={<EditIcon />}
              label="Edit"
              className="textPrimary"
              component={Link}
              to={{
                pathname: `/authors/create/`,
                state: { id: params.id },
              }}
              color="inherit"
            />,
            <GridActionsCellItem
              icon={<DeleteIcon />}
              label="Delete"
              onClick={() => deleteRow(params.id)}
              color="inherit"
            />,
          ];
        },
      },
      { field: "id", headerName: "ID", width: 100 },
      { field: "name", headerName: "Name", width: COLUMN_WIDTH },
      { field: "slug", headerName: "Slug", width: COLUMN_WIDTH },
      { field: "active", headerName: "Is active?", width: 150 },
    ],
    [deleteRow]
  );

  const initialState = {
    columns: [],
    rows: [],
  };
  const [state, setState] = useState(initialState);

  function createRowsList(rows, cols) {
    let validrows = [];
    rows &&
      rows.forEach((row) => {
        let validrow = {};
        cols &&
          cols.forEach((col) => {
            switch (col.field) {
              case "active":
                if (row[col.field]) {
                  validrow[col.field] = "✔";
                } else {
                  validrow[col.field] = "×";
                }
                break;
              default:
                validrow[col.field] = row[col.field];
                validrow["id"] = row["id"];
            }
          });
        validrows.push(validrow);
      });
    return validrows;
  }

  const newRow = () => {
    history.push({
      pathname: "/authors/create/",
    });
  };

  useEffect(() => {
    API.getItems("authors", token)
      .then((resp) => {
        const rows = createRowsList(resp, columns);
        setState({
          ...state,
          columns: columns,
          rows: rows,
        });
      })
      .catch((error) => console.log(error));
  }, []);
  return (
    <React.Fragment>
      <div className="content-wrapper">
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1>Authors</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <a href="#">Home</a>
                  </li>
                  <li className="breadcrumb-item active">Authors</li>
                </ol>
              </div>
            </div>
          </div>
          {/* /.container-fluid */}
        </section>
        {/* Main content */}
        <section className="content">
          <div className="card card-default">
            {/* <div className="col-sm-6" style={selectStore}>
                <StoreSelection />
              </div> */}
            <div className="card-body">
              <div className="toolbar row ustorekit-common-under-margin-10">
                <div className="col-md-2">
                  <button
                    className="cell-button btn btn-success"
                    onClick={newRow}
                  >
                    Add a author
                  </button>
                </div>
              </div>
              <span>{/* {selectedIndexes.length} {rowText} selected */}</span>
              <div className="relativeWrapper">
                <div className="absoluteWrapper"></div>
                <DataGrid
                  rows={state.rows}
                  columns={columns}
                  initialState={{
                    pagination: { paginationModel: { pageSize: 15 } },
                  }}
                  pageSizeOptions={[15, 25, 50, 100]}
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </React.Fragment>
  );
}
